import Carousel1 from "../../components/carousel/carousel";
import EachProCom from "../../components/eachProCom/eachProCom";
import { handleGetDatas } from "../../requests/productRequests";
import "./eachProduct.css"
import { useEffect , useState } from "react";

function EachProduct(){
    const [data , setData] = useState([])
    useEffect(async () => {
        const res = await handleGetDatas()
        setData(res)
    } , [])
    return(
        <div className="eachproduct">
            <div className="eachproduct-container">
                <EachProCom/>
                <Carousel1 data={data} title={"محصولات مشابه"}/>
            </div>
        </div>
    )
}

export default EachProduct;